import React from "react";
import { Grid, Hidden, makeStyles, Box, Divider } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import TitleText from "../../components/reusableComponents/TitleText";
import whitelogo from "../../assets/images/whitelogo.png";
import servicebanner from "../../assets/images/servicesbanner.png";
import BodyText from "../../components/reusableComponents/BodyText";
import { useSelector } from "react-redux";
// import XLScreenFooter from './XLScreenFooter';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: "#010825 !important",
    marginTop: 10,
    paddingTop: 20,
    paddingBottom: 20,
  },
  link: {
    textDecoration: "none",
    color: "#C4C4C4",
  },
  SolutionDiv: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      marginTop: 30,
      paddingRight: 0,
      order: 2,
    },
  },
  ExploreDiv: {
    marginTop: 10,
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      marginTop: 20,
      order: 1,
      paddingRight: 0,
    },
  },
  ExploreinnerDiv: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
  },
  logoDiv: {
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      marginTop: 20,
      order: 3,
    },
  },
  logoImage: {
    marginBottom: 40,
    marginTop: 50,
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));
const row1 = [
  "Company Info",
  "Company Policy",
  "Privacy Policy",
  "Terms & Conditions",
  "User Agreement",
  "About Us",
  "Careers",
  "Disclaimer",
  "Contact Us",
  "Cancellation/ Refund Policy",
  "Baggage Allowance",
];

const row2 = [
  "Flight Booking",
  "Hotel Booking",
  "Bus Booking",
  "Cab Booking",
  "Holidays Booking",
  "Forex",
  "Insurance",
  "Bill Payments",
];

const row3 = ["Partner With Us", "Agent Login"];
const row4 = [
  "Domestic Flights",
  "International Flights",
  "Domestic Hotels",
  "International Hotels",
  "Domestic Bus Routes",
  "Airports In India",
  "International Airports",
  "Domestic Airlines",
  "International Airlines",
  "Airline Customer care",
];
const row5 = [
  "Corporate Office",
  "Branch Office",
  "Customer Care",
  "Feedback Form",
  "Client Testimonials",
  "Site Map",
  "FAQs",
];
const Footer = () => {
  const classes = useStyles();
  const { footer_menu, footer_submenu } = useSelector((state) => state.home);
  const history = useHistory();
  let row = [];
  let rown2 = [];
  let rown3 = [];
  let rown4 = [];
  let rown5 = [];
  let rown6 = [];
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[0].id) {
        row.push({
          ...item,
        });
      }
    });
  }
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[1].id) {
        rown2.push({
          ...item,
        });
      }
    });
  }
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[2].id) {
        rown3.push({
          ...item,
        });
      }
    });
  }
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[3].id) {
        rown4.push({
          ...item,
        });
      }
    });
  }
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[4].id) {
        rown5.push({
          ...item,
        });
      }
    });
  }
  if (footer_menu && footer_submenu) {
    footer_submenu?.result.map((item, index) => {
      if (item.parentid === footer_menu?.result[5].id) {
        rown6.push({
          ...item,
        });
      }
    });
  }
  console.log("ROW1", rown5);
  return (
    <>
      <Hidden xlUp>
        <div
          className={classes.mainContainer}
          style={{ paddingLeft: 50, paddingRight: 50 }}
        >
          {/* <Grid container  justify='center'>
          <Grid container style={{ alignItems: 'self-end' }}>
            <Grid item xs={12} lg={6}>
              <p style={{ fontSize: 36, color: 'white', textAlign: 'right' }}>1800 8890 743</p>
            </Grid>
            <Grid item xs={12} lg={6} style={{ textAlign: 'center' }}>
              <p style={{
                marginBottom: '12px',
                color: '#d6d6d6',
                fontSize: '14px'
              }}>10:00 AM - 6:00 PM (EST), Monday - Friday</p>
            </Grid>
          </Grid>
          
        </Grid> */}
          <Box
            style={{
              border: "1px solid #727272",
              borderRadius: "12px",
              padding: "7px 3px 3px 2px",
            }}
          >
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={8} style={{ textAlign: "center" }}>
                {/* <p style={{
                  marginBottom: '12px',
                  color: '#d6d6d6',
                  fontSize: '14px'
                }}>Block - B 31, First Floor, Chandigarh Citi Center, VIP Rd, Zirakpur, Punjab 140603     info@marinersforex.com</p> */}
                <h4 style={{ color: "white" }}>
                  Chandigarh - Dhanbad - Dubai - USA
                </h4>
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </Box>
          <Grid container style={{ padding: 40 }}>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[0]?.name}
                </h6>
                {row?.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[1]?.name}
                </h6>
                {rown2?.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[2]?.name}
                </h6>
                {rown3?.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[3]?.name}
                </h6>
                {rown4?.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[4]?.name}
                </h6>
                {rown5?.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12} lg={2}>
              <Box>
                <h6 style={{ color: "white" }}>
                  {footer_menu?.result[5]?.name}
                </h6>
                {rown6.map((i) => {
                  return i.link_url ? (
                    <>
                      <a href={i.link_url} target="_blank">
                        <span style={{ color: "grey", fontSize: 12 }}>
                          {i.name}
                        </span>
                      </a>
                      <br />
                    </>
                  ) : (
                    <>
                      <span style={{ color: "grey", fontSize: 12,cursor:'pointer' }} onClick={()=>history.push({
                        pathname:`/footer/${i.link}`,
                        state:i
                      })}>
                        {i.name}
                      </span>
                      <br />
                    </>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
          {/* <Box style={{textAlign:'end'}}>
        <img src={servicebanner}></img>
      </Box> */}
          <Divider style={{ background: "grey", marginTop: 10 }} />
          <h5 style={{ textAlign: "center", color: "white" }}>
            Copyright ©2022, All Rights Reserved. Powered by Arya Aviation India
            Pvt. Ltd.
          </h5>
        </div>
      </Hidden>
      {/* <Hidden lgDown>
        <XLScreenFooter />
      </Hidden> */}
    </>
  );
};

export default Footer;
